// **** import modules ****
import app, { csl, vuwer } from "@@assets/scripts/common";
import "@@assets/klass/VuwSlider";
import "./_pageHeader";
import "./_posts";
import "./_instagram";
import "./_menu";
import "./_takeout";
import "./_special";
import "./_about";
import "./information/_index";


// **** process ****
vuwer.get("body").smoothScrollBuffer = 40;

app.onReady((...args) => {
	csl.log.orange(`${app.pageName} onReady`, ...args);
});

app.exec();
